import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { InfoDay } from '../../comun/recipient-services/info-day';
import { ServicePoint } from '../../comun/recipient-services/service-point';

@Injectable()
export class ShipmentChangesService extends ApiService  {

  constructor() {
    super('shipment-changes');
  }

  search(numberExpeditionTLG: string, zipCode?: string): Observable<Array<ServicePoint>> {
    const options = {
      params: new HttpParams()
        .set('tlgExpeditionNumber', numberExpeditionTLG)
    };

    if (zipCode) {
      options.params = options.params.set('zipCode', zipCode);
    }

    return this.http.get<Array<ServicePoint>>(this.url('servicepoints'), options);
  }

  daysAvailableChangeDelivery(numberExpeditionTLG: string, totalDays?: number): Observable<Array<InfoDay>> {


    let params = new HttpParams()
      .set('tlgExpeditionNumber', numberExpeditionTLG);
    if (totalDays) {
      params = params.set('totalDays', String(totalDays));
    }
    // llamada a la api
    return this.http.get<Array<InfoDay>>(this.url('available-days'), { params: params });
  }
}
